import { bimProjectsAPI } from "@/views/BimProjects/services/api";
import { residentDictionaryAPI } from "@/views/ResidentDictionary/services/api";

export const getBimProjects = async (params = {}) => {
  try {
    const res = await bimProjectsAPI.getList(params);
    return res?.data;
  } catch (e) {}
};

export const saveBimProject = async (data) => {
  try {
    const res = await bimProjectsAPI.save(data);
    return res;
  } catch (e) {}
};

export const deleteBimProject = async (bim_project_id) => {
  try {
    const res = await bimProjectsAPI.delete(bim_project_id);
    return res;
  } catch (e) {}
};

export const getDigitalProjectForImport = async (bim_project_id) => {
  try {
    const res = await bimProjectsAPI.getDigitalProjectForImport(bim_project_id);
    return res;
  } catch (e) {
    throw e;
  }
};

export const importBimProjectJson = async (bim_project_id, formData) => {
  const res = await bimProjectsAPI.importJson(bim_project_id, formData);
  return res;
};

export const importBimProjectExcel = async (bim_project_id, formData) => {
  const res = await bimProjectsAPI.importExcel(bim_project_id, formData);
  return res;
};

// Справочники
export const getBimCategories = async (bim_project_id = null) => {
  try {
    const res = await bimProjectsAPI.getCategories(bim_project_id);
    return res?.data;
  } catch (e) {}
};

export const getBimTypes = async () => {
  try {
    const res = await bimProjectsAPI.getTypes();
    return res?.data;
  } catch (e) {}
};

export const getBimParams = async () => {
  try {
    const res = await bimProjectsAPI.getParams();
    return res?.data;
  } catch (e) {}
};

// Items
export const getBimProjectItems = async (bim_project_id, bim_category_id = null) => {
  try {
    const res = await bimProjectsAPI.getItems(bim_project_id, bim_category_id);
    return res?.data;
  } catch (e) {}
};

export const getBimProjectItemJson = async (bim_project_item_id) => {
  try {
    const res = await bimProjectsAPI.getItemJson(bim_project_item_id);
    return res?.data;
  } catch (e) {}
};

export const saveBimProjectItem = async (data) => {
  try {
    const res = await bimProjectsAPI.saveItem(data);
    return res;
  } catch (e) {}
};

export const deleteBimProjectItem = async (bim_project_item_id) => {
  try {
    const res = await bimProjectsAPI.deleteItem(bim_project_item_id);
    return res;
  } catch (e) {}
};

export const deleteBimProjectItems = async (bim_project_item_ids) => {
  try {
    const res = await bimProjectsAPI.deleteItems(bim_project_item_ids);
    return res;
  } catch (e) {}
};

export const copyBimProjectItemsToFloors = async (bim_project_item_ids, bim_level_nums) => {
  try {
    const res = await bimProjectsAPI.copyItemsToFloors(bim_project_item_ids, bim_level_nums);
    return res;
  } catch (e) {
    throw e;
  }
};

export const updateBimProjectItemsLevel = async (bim_project_item_ids, bim_level_num) => {
  try {
    const res = await bimProjectsAPI.updateItemsLevel(bim_project_item_ids, bim_level_num);
    return res;
  } catch (e) {
    throw e;
  }
};

// Floor schemes
export const getBimProjectFloorSchemes = async (bim_project_id) => {
  try {
    const res = await bimProjectsAPI.getFloorSchemes(bim_project_id);
    return res?.data;
  } catch (e) {}
};

export const getBimProjectFloorSchemeGeometry = async (bim_project_id, bim_level_num) => {
  try {
    const res = await bimProjectsAPI.getFloorSchemeGeometry(bim_project_id, bim_level_num);
    return res?.data;
  } catch (e) {}
};

export const saveBimProjectFloorScheme = async (data) => {
  try {
    const res = await bimProjectsAPI.saveFloorScheme(data);
    return res;
  } catch (e) {}
};

export const getBimTypesByCategory = async (bim_category_id) => {
  try {
    const res = await bimProjectsAPI.getBimTypesByCategory(bim_category_id);
    return res?.data;
  } catch (e) {
    return [];
  }
};

export const deleteBimProjectFloorScheme = async (bim_project_floor_scheme_id) => {
  try {
    const res = await bimProjectsAPI.deleteFloorScheme(bim_project_floor_scheme_id);
    return res;
  } catch (e) {}
};

export const saveBimProjectFloorSchemeCalibration = async (data) => {
  try {
    const res = await bimProjectsAPI.saveFloorSchemeCalibration(data);
    return res;
  } catch (e) {}
};

export const copyBimProjectFloorSchemeToFloors = async (data) => {
  const res = await bimProjectsAPI.copyFloorSchemeToFloors(data);
  return res;
};

// Типы линий
export const getFloorParamTypes = async () => {
  try {
    const res = await bimProjectsAPI.getFloorParamTypes();
    return res?.data;
  } catch (e) {}
};


// Новые упрощенные методы для параметров расчета
export const getBimProjectCalcParams = async (bim_project_id) => {
  try {
    const res = await bimProjectsAPI.getCalcParams(bim_project_id);
    return res?.data;
  } catch (e) {
    console.error('Ошибка загрузки параметров расчета:', e);
  }
};

export const saveBimProjectCalcParams = async (bim_project_id, params) => {
  try {
    const res = await bimProjectsAPI.saveCalcParams(bim_project_id, params);
    return res;
  } catch (e) {
    console.error('Ошибка сохранения параметров расчета:', e);
    throw e;
  }
};

/** Список ЖК для селекта (resident_id, resident_name), БД: resident__dict_read */
export const getResidentsForSelect = async (params = {}) => {
  try {
    const res = await residentDictionaryAPI.readSelect(params);
    return res?.data ?? [];
  } catch (e) {
    console.error("Ошибка загрузки списка ЖК:", e);
    return [];
  }
};
